import { createContext, useContext } from "react";

import { AllowAllEntityPermissions } from "@av/config/api-config/permissions/common/allow-all-entity-permissions.class";
import type { IEntityPermissions } from "@av/config/api-config/permissions/entity-permissions.interface";

import type { FormMetaContextType } from "../types";

export const FormMetaContext = createContext<FormMetaContextType>({
  trackProps: () => {},
  trackedFieldProps: {},
  permissions: undefined,
});

export function useEntityPermissions(): IEntityPermissions {
  const { permissions } = useContext(FormMetaContext);

  if (!permissions?.isFieldEditable || !permissions?.isFieldViewable) {
    return new AllowAllEntityPermissions();
  }

  return permissions;
}
